module.exports = __webpack_public_path__ + "user-618fa00d24b18e2a0ba8.svg";